// Serialize saves so a slower, older request cannot overwrite newer answers.
function createSurveyAutosave({ save, onStatus = () => {}, delay = 700 }) {
  let latest = null;
  let version = 0;
  let savedVersion = 0;
  let timer = null;
  let running = null;
  let stopped = false;
  let listenersActive = true;
  const status = (value) => { if (listenersActive) onStatus(value); };
  const clearTimer = () => { if (timer !== null) clearTimeout(timer); timer = null; };

  async function drain() {
    status('saving');
    try {
      while (savedVersion < version) {
        const targetVersion = version;
        const snapshot = latest;
        await save(snapshot);
        savedVersion = targetVersion;
      }
      status('saved');
    } catch (error) {
      status('error');
      throw error;
    }
  }

  async function flush() {
    clearTimer();
    if (running) {
      await running;
      return savedVersion < version ? flush() : undefined;
    }
    if (savedVersion === version) return Promise.resolve();
    running = drain().finally(() => { running = null; });
    return running;
  }

  return {
    update(snapshot) {
      if (stopped) return;
      latest = JSON.parse(JSON.stringify(snapshot));
      version += 1;
      status('pending');
      clearTimer();
      timer = setTimeout(() => { timer = null; flush().catch(() => {}); }, delay);
    },
    flush,
    isDirty: () => savedVersion < version,
    stop() { stopped = true; clearTimer(); },
    dispose() { stopped = true; listenersActive = false; clearTimer(); },
  };
}

module.exports = { createSurveyAutosave };
